const Progress = ({ value, stepLabel }) => {
  const parsed = parseInt(value, 10) || 0;
  const filledWidth = Math.min(Math.max(parsed, 0), 100);

  return (
    <div
      className="acoris-progress"
      style={{ "--progress": `${filledWidth}%` }}
    >
      <div className="acoris-progress__filled" />
      {(parsed > 0 || stepLabel) && (
        <div className="acoris-progress__badge">
          <span className="acoris-progress__percent">{parsed}%</span>
          {stepLabel && (
            <>
              <span className="acoris-progress__divider">|</span>
              <span className="acoris-progress__step">{stepLabel}</span>
            </>
          )}
        </div>
      )}
      <div className="acoris-progress__remaining" />
    </div>
  );
};

export default Progress;
